import {Component, OnInit} from '@angular/core';
import {ApiService} from "../services/api.service";
import {DataService} from "../services/data.service";
import {UserRole} from "../type/user-role";

@Component({
    selector: 'app-user-roles',
    templateUrl: './user-roles.component.html',
})
export class UserRolesComponent implements OnInit {
    node = 'user-role';
    userRoles: [UserRole] = [UserRole];

    isChecked = false;
    checkedList = [];
    getPerm;
    postPerm;
    putPerm;
    deletePerm;

    constructor(
        private dataService: DataService,
        private apiService: ApiService
    ) {
        this.getPerm = this.dataService.checkPermission(this.node, 'GET');
        this.postPerm = this.dataService.checkPermission(this.node, 'POST');
        this.putPerm = this.dataService.checkPermission(this.node, 'PUT');
        this.deletePerm = this.dataService.checkPermission(this.node, 'DELETE');
    }

    ngOnInit() {
        this.dataService.refresh();
        this.getAll();
    }

    resetData() {
        this.getAll();
        this.isChecked = false;
        this.checkedList = [];
    }

    getAll(): void {
        this.apiService.getAll(this.node)
            .subscribe((response) => {
                this.dataService.updateActiveRequestNo(-1);
                if (response.json().error == true) {
                    this.userRoles = [UserRole];
                } else {
                    this.userRoles = response.json().data;
                }
            });
    }

    onDelete() {
        if (confirm('Are you absolutely sure you want to delete?')) {
            this.apiService.delete(this.node, this.checkedList)
                .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        alert('Unable to delete User Role');
                    } else {
                        this.resetData();
                        alert('User Role Deleted Successfully');
                    }
                });
        }
    }

    updateCheckList(id) {
        if (this.checkedList.indexOf(id) == -1) {
            this.checkedList.push(id);
        } else {
            this.checkedList.splice(this.checkedList.indexOf(id), 1);
        }
    }

    toggleCheckBox() {
        this.isChecked = !this.isChecked;
        if (this.isChecked == true) {
            this.checkedList = this.userRoles.map(function(a) {return a.user_role_id;});
        } else {
            this.checkedList = [];
        }
    }

    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }
}



// WEBPACK FOOTER //
// ./src/app/user-roles/user-roles.component.ts